// Captura un fotograma de un video (File o URL del mismo origen) y devuelve un Blob JPEG.
// Se usa para generar la imagen de vista previa (Open Graph) cuando el fondo/portada es video.
export async function captureVideoPosterBlob(src) {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    video.muted = true;
    video.playsInline = true;
    video.preload = "auto";

    let objectUrl = null;
    if (src instanceof Blob) {
      objectUrl = URL.createObjectURL(src);
      video.src = objectUrl;
    } else {
      video.src = src;
    }

    const cleanup = () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      video.removeAttribute("src");
    };

    const timer = setTimeout(() => {
      cleanup();
      reject(new Error("timeout"));
    }, 15000);

    const draw = () => {
      try {
        const w = video.videoWidth || 1280;
        const h = video.videoHeight || 720;
        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, w, h);
        canvas.toBlob(
          (blob) => {
            clearTimeout(timer);
            cleanup();
            blob ? resolve(blob) : reject(new Error("no-blob"));
          },
          "image/jpeg",
          0.85
        );
      } catch (err) {
        clearTimeout(timer);
        cleanup();
        reject(err);
      }
    };

    video.onloadeddata = () => {
      const t = Math.min(1, (video.duration || 2) / 2);
      try {
        video.currentTime = t;
      } catch (e) {
        draw();
      }
    };
    video.onseeked = draw;
    video.onerror = () => {
      clearTimeout(timer);
      cleanup();
      reject(new Error("video-error"));
    };
  });
}

export function blobToFile(blob, name = "poster.jpg") {
  return new File([blob], name, { type: blob.type || "image/jpeg" });
}
